/**
 * Drops empty values so axios doesn't serialize them as the literal string "undefined".
 *
 * Every list service needs this, so it lives here rather than being re-declared per file.
 */
export const cleanParams = <T extends Record<string, unknown>>(input: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === '' || value === null) continue;
    out[key] = value;
  }
  return out as Partial<T>;
};
